import { authorize, postRequest } from 'utils/http';
import { AWS_API_URL } from 'global/environment';
import { mapDataForBackend } from './mapData';

export async function submitInternetSubscriptionAPI(subscription) {
  const backendURL = `${AWS_API_URL}/user/subscriptions`;

  return postRequest(backendURL, { data: mapDataForBackend(subscription) }, await authorize());
}
